import { createContext } from "react";

import { SUPPORT_EMAIL } from "@/constants/common.constants";

export const DEFAULT_PRIMARY_COLOR = "#FF720B";
export const DEFAULT_PLATFORM_TITLE = "Tournated";

export type BrandColorContextValue = {
  brandColor: string | null;
  setBrandColor: (brandColor: string | null) => void;
  title: string;
  setTitle: (title: string) => void;
  lightLogo: string | null;
  darkLogo: string | null;
  setLightLogo: (lightLogo: string | null) => void;
  setDarkLogo: (darkLogo: string | null) => void;
  lightEmblem: string | null;
  darkEmblem: string | null;
  setLightEmblem: (lightEmblem: string | null) => void;
  setDarkEmblem: (darkEmblem: string | null) => void;
  favicon: string | null;
  setFavicon: (favicon: string | null) => void;
  supportEmail: string;
  setSupportEmail: (supportEmail: string) => void;
  isWhiteLabeled: boolean;
  setIsWhiteLabeled: (isWhiteLabeled: boolean) => void;
  isBrandingLoading: boolean;
  setIsBrandingLoading: (isBrandingLoading: boolean) => void;
};

export const BrandColorContext = createContext<BrandColorContextValue>({
  brandColor: DEFAULT_PRIMARY_COLOR,
  setBrandColor: () => {},
  title: DEFAULT_PLATFORM_TITLE,
  setTitle: () => {},
  lightLogo: null,
  darkLogo: null,
  setLightLogo: () => {},
  setDarkLogo: () => {},
  lightEmblem: null,
  darkEmblem: null,
  setLightEmblem: () => {},
  setDarkEmblem: () => {},
  favicon: null,
  setFavicon: () => {},
  supportEmail: SUPPORT_EMAIL,
  setSupportEmail: () => {},
  isWhiteLabeled: false,
  setIsWhiteLabeled: () => {},
  isBrandingLoading: false,
  setIsBrandingLoading: () => {},
});
